import { gql } from '@apollo/client'
import { useMutation } from '@apollo/client'

const SAVE_REPORT_SCHEDULE = gql`
  mutation SaveReportSchedule($reportScheduleInfo: ReportScheduleInfo!) {
    saveReportSchedule(reportScheduleInfo: $reportScheduleInfo) {
      id
      report_type_id
      name
      frequency
      recipients
      subject
      options
      is_enabled
      shops {
        id
        name
        address
      }
      reportType {
        id
        key
        name
        description
        created_at
        updated_at
      }
    }
  }
`

const DELETE_REPORT_SCHEDULE = gql`
  mutation DeleteReportSchedule($id: ID!) {
    deleteReportSchedule(id: $id)
  }
`

const GENERATE_REPORT_QUICK = gql`
  mutation GenerateReport($input: GenerateReportInput!) {
    generateReport(input: $input) {
      success
      message
      fileUrl
    }
  }
`

const GENERATE_REPORT = gql`
  mutation RunReportSchedule($id: ID!) {
    runReportSchedule(id: $id)
  }
`

const TOGGLE_REPORT_SCHEDULE = gql`
  mutation ToggleReportSchedule($id: ID!) {
    toggleReportSchedule(id: $id) {
      id
      is_enabled
    }
  }
`

export const useSaveReportSchedule = () => useMutation(SAVE_REPORT_SCHEDULE)

export const useDeleteReportSchedule = () => useMutation(DELETE_REPORT_SCHEDULE)

export const useGenerateReport = () => useMutation(GENERATE_REPORT)

export const useGenerateReportQuick = () => useMutation(GENERATE_REPORT_QUICK)

export const useToggleReportSchedule = () => useMutation(TOGGLE_REPORT_SCHEDULE)

// Backward compatibility aliases
export const useCreateReportSchedule = () => useMutation(SAVE_REPORT_SCHEDULE)
export const useUpdateReportSchedule = () => useMutation(SAVE_REPORT_SCHEDULE)
